import React, { PureComponent } from 'react';
import classnames from 'classnames';
import Icon from '~/core/scripts/components/Icon';
// import SectionTitle from '~/kits/general/SectionTitle';
import { steps, getCurrentScale } from '~/kits/general/utils';
import Utils from '~/core/scripts/utils';

class TableView extends PureComponent {

  render() {
    const { data, currentStep } = this.props;
    const step = steps[currentStep];
    const tableData = data.sort(Utils.sortByKey(step, true)).slice(0, 10);
    const tableSublineLabel = step === 'Deutschland' ? 'ganz Deutschland' : step;

    return (
      <div className="listview">
        {/* <div className="maplegend__title hd__title">
          <div className="hd__title-text">
            <div className="hd__title-main">Top-Reiseziele in der EU</div>
            <div className="hd__title-sub">für {tableSublineLabel}</div>
          </div>
        </div> */}
        <ul className="list">
          {tableData.map((d, i) => (
            <li className={classnames('list__item', `step-${getCurrentScale(d[step])}`)} key={d.reiseland}>
              <div className="list__index">{i + 1}</div>
              <div className="list__name">{d.reiseland}</div>
              <div className="list__value">{Utils.numberFormat(d[step], 1)} %</div>
              <div className="list__value-light">({Utils.numberFormat(d[`${step}_referenz`], 1)} %)</div>
            </li>
          ))}
        </ul>
        <div className="list__coldesc">Top-Auslandsziele: Anteile von deutschen Handy-Nutzern in den <strong>Sommerferien</strong> (und Vergleichswert die ferienfreie Zeit)</div>
        <div className="info-button" onClick={window.toggleInfoBox}>Weitere Informationen <Icon type="info" /></div>
      </div>
    );
  }
}

export default TableView;
